import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchAct = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});



export const fetchActivitiesData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,userid:'1'};
            const apiname = SUPRIVISOR_API.sactivities;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAct(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

